import * as React from "react"
import { Tab, Tabs, Row, Col, Modal } from "react-bootstrap"
import PoolStatistics from "../GovPools/PoolStatistics"
import GovPoolGeneralInfo from "./PoolGeneralInfo"
import ImportPoolMembers from "../Pools/ImportPoolMembers"
import { AppState, CurrentUserPermissions } from "../../../AppState"
import { connect } from "react-redux"
import GridRow from "../../../api/Randoms/GovPoolModel/GridRow"
import { BuildUserAccess } from "../../../authentication/BuildUserAccess"
import { control } from "leaflet"

export interface PoolDetailsModalProps {
  details: GridRow
  onHide: (hasUpdates: boolean) => void
}
export interface PoolDetailsModalAppStateProps {
  showRunRandom: boolean
  showPersonnelImport: boolean
}

interface PoolDetailsModalState {
  currentTab: string
  updated: boolean
}

const StatisticsKey = "statistics"
const GeneralInformationKey = "general_information"

export class PoolDetailsModal extends React.PureComponent<PoolDetailsModalProps & PoolDetailsModalAppStateProps, PoolDetailsModalState> {
  state: PoolDetailsModalState = {
    currentTab: StatisticsKey,
    updated: false
  }

  onHide = () => { this.props.onHide(this.state.updated) }
  onUpdate = () => this.setState({ updated: true })
  handleRunFinish = () => this.setState({ currentTab: StatisticsKey })

  render() {
    const {details } = this.props

    return (
      <Modal backdrop="static" show={true} onHide={this.onHide} size="xl" dialogClassName="modal-90w">
        <Modal.Header closeButton>
          <Modal.Title>GROUP DETAILS</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="tab-container">
            <Row className="px-0 pt-2">
              <Col>
                <h4 className="px-4"><span className="text-uppercase">{details.Name}</span></h4>
                <Tabs defaultActiveKey={StatisticsKey} activeKey={this.state.currentTab} className="px-4 py-2" onSelect={(eventKey) => { eventKey && this.setState({ currentTab: eventKey }) }}>
                  <Tab eventKey={StatisticsKey} title="STATISTICS">
                    {StatisticsKey === this.state.currentTab && <PoolStatistics poolId={details.PoolID} poolName={details.Name} />}
                  </Tab>
                  <Tab eventKey={GeneralInformationKey} title="GENERAL INFORMATION">
                    {GeneralInformationKey === this.state.currentTab && <GovPoolGeneralInfo details={details} onUpdate={this.onUpdate} />}
                  </Tab>
                  {this.props.showPersonnelImport && <Tab eventKey="personnel_import" title="PERSONNEL IMPORT">
                    <ImportPoolMembers poolID={details.PoolID} isGovt onUpdate={this.onUpdate} />
                  </Tab>}
                </Tabs>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

function mapStateToProps(state: AppState): PoolDetailsModalAppStateProps{
  const userAccess = BuildUserAccess(state);
  return {
    showRunRandom: userAccess.CanManageGovPools,
    showPersonnelImport: userAccess.CanManageGovDonors,
  }
}
const ConnectedPoolDetailsModal = connect(mapStateToProps)(PoolDetailsModal)
export default ConnectedPoolDetailsModal
